
import { dispatchAdminGetReports } from '@/store/admin/actions';
import { Component, Vue } from 'vue-property-decorator';
import { readAdminCompanyReports } from '@/store/admin/getters';
import { ReportRow } from '@/store/admin/index';
import { commitSetReportId, commitSetReports } from '@/store/report/mutations';
import { commitSetCompanyId } from '@/store/admin/mutations';
import ReenterRequestDiaglog from './ReenterRequestDiaglog.vue';
import CompleteDiaglog from './CompleteDiaglog.vue';

@Component({
  components: {
    ReenterRequestDiaglog,
    CompleteDiaglog,
  },
})
export default class Reports extends Vue {
  public headers = [
    { text: "レポートID", value: "report_id", groupable: false },
    { text: "作成日時", align: "start", value: "company_created_at" },
    { text: "企業名", value: "company_name" },
    { text: "レポート出力申請", value: "report_created_at" },
    { text: '', value: 'links', sortable: false, groupable: false },
  ];
  public reports: ReportRow[] = [];
  public search: string = '';
  public complete_dialog = false;

  public async mounted() {
    await dispatchAdminGetReports(this.$store);
    this.reset();
  }

  public async reload() {
    await dispatchAdminGetReports(this.$store);
    this.reset();
  }

  public reset() {
    let reports: ReportRow[] = [];

    const adminCompanyReports = readAdminCompanyReports(this.$store);
    if (adminCompanyReports) {
      for (let companyReport of adminCompanyReports) {
        for (let report of companyReport.reports) {
          reports.push({
            company_created_at: this.formatDate(new Date(companyReport.company.created_at)),
            company_name: companyReport.company.name,
            report_created_at: this.formatDate(new Date(report.created_at)),
            report_id: report.id,
            result_uploaded: report.result_uploaded,
            result_completed_at: report.result_completed_at,
            reenter_request: report.reenter_request,
            reports: companyReport.reports,
            company: companyReport.company,
          });
        }
      }
    }
    this.reports = reports;
  }

  public moveToAccountInfo(item) {
    commitSetCompanyId(this.$store, item.company.id);
    this.$router.push('/main/user/account-info');
  }

  public moveToReport(item) {
    commitSetReportId(this.$store, item.report_id);
    commitSetReports(this.$store, item.reports.reverse());
    this.$router.push('/main/dashboard');
  }

  public moveToReportInput(item) {
    commitSetReportId(this.$store, item.report_id);
    this.$router.push('/main/report/source');
  }

  public formatDate(date: Date | null): string {
    let formatDate = ''
    if (date) {
      formatDate = date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + date.getDate();
    }
    return formatDate;
  }
}
